import { render, staticRenderFns } from "./IconTypeformShortText.vue?vue&type=template&id=52850afb&"
import script from "./IconTypeformShortText.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformShortText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports